<template>
  <div id="progresso" class="d-flex align-center justify-center">
    <div>
      <div class="animacao">
        <div class="bolinha" />
        <div class="bolinha" style="animation-delay: .1s;" />
        <div class="bolinha" style="animation-delay: .3s;" />
      </div>

      <p id="descricao">Um momento, por favor</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProgressoCarregamentoFase"
}
</script>

<style scoped>
#progresso {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
#descricao {
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: rgba(0, 0, 0, 0.6);
  margin: 8px 0;
}

.animacao {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 10px;
}
.animacao .bolinha {
  background: #00988F;
  width: 8px;
  height: 8px;
  margin-right: 4px;
  border-radius: 50%;
  animation: para-cima-e-baixo .5s alternate infinite;
}

@keyframes para-cima-e-baixo {
  0% {
    margin-top: 0;
  }
  25% {
    margin-top: -3px;
  }
  50% {
    margin-top: -6px;
  }
  75% {
    margin-top: -9px;
  }
  100% {
    margin-top: -12px;
  }
}
</style>
